<template>
    <v-card class="tag-edit-dialog-card">
        <v-row class="tag-edit-dialog-header">
            <v-col
                cols="12"
                class="d-flex align-center justify-space-between"
                :class="{
                    'py-4 px-12': $vuetify.breakpoint.smAndUp,
                    'py-4 px-3': $vuetify.breakpoint.xsOnly,
                }"
            >
                <h2>Create tag</h2>
                <v-btn icon :large="$vuetify.breakpoint.smAndUp" @click="hideModal()">
                    <v-icon :large="$vuetify.breakpoint.smAndUp">close</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="12" class="pa-0 ma-0">
                <v-divider class="mx-0"></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col
                cols="12"
                :class="{
                    'pa-12': $vuetify.breakpoint.smAndUp,
                    'py-12 px-3': $vuetify.breakpoint.xsOnly,
                }"
            >
                <v-form ref="editTagForm" :lazy-validation="true">
                    <v-text-field v-model="tag.key_en" clearable color="pink" label="key" required></v-text-field>
                    <v-text-field v-model="tag.key_gr" clearable color="pink" label="key_gr" required></v-text-field>
                    <v-text-field v-model="tag.name_en" clearable color="pink" label="name" required></v-text-field>
                    <v-text-field v-model="tag.name_gr" clearable color="pink" label="name_gr" required></v-text-field>
                    <v-select
                        v-model="tag.only_for_search"
                        :items="[
                            { label: 'true', value: true },
                            { label: 'false', value: false },
                        ]"
                        label="Only for Search"
                        item-text="label"
                        item-value="value"
                        color="pink"
                    ></v-select>
                    <v-text-field v-model="tag.generic_key" clearable color="pink" label="generic_key" required></v-text-field>
                    <v-select
                        v-model="tag.is_main"
                        :items="[
                            { label: 'true', value: true },
                            { label: 'false', value: false },
                        ]"
                        label="is_generic"
                        item-text="label"
                        item-value="value"
                        color="pink"
                    ></v-select>
                    <v-text-field v-model="tag.relative_tag_ids" clearable color="pink" label="relative_tag_ids"></v-text-field>
                    <v-btn block x-large color="primary" elevation="12" @click="validateEditTagForm()">
                        Submit
                    </v-btn>
                </v-form>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex';
import { SET_SNACKBAR_STATUS } from '@/store/mutation-types';
import { BusinessOptionsApi } from '@/api';

export default {
    name: 'EditTag',
    props: {
        tag: {
            type: Object,
            required: true,
        },
        mode: {
            type: String,
            default: 'create',
        },
    },
    data: () => ({}),
    methods: {
        ...mapMutations('BusinessOptions', {
            addTagMutation: 'addTagMutation',
            editTagMutation: 'editTagMutation',
        }),
        validateEditTagForm() {
            if (this.$refs.editTagForm.validate()) {
                if (this.mode === 'create') {
                    this.createTag();
                } else {
                    this.updateTag();
                }
            }
        },
        async createTag() {
            this.tag['key'] = this.tag['key_en'];
            this.tag['name'] = this.tag['name_en'];
            const { data } = await BusinessOptionsApi.createTag(this.tag);
            this.addTagMutation(data);
            this.$store.commit(SET_SNACKBAR_STATUS, { message: 'Tag created successfully', color: 'success' });
            this.hideModal();
        },
        async updateTag() {
            this.tag['key'] = this.tag['key_en'];
            this.tag['name'] = this.tag['name_en'];
            const { data } = await BusinessOptionsApi.updateTag(this.tag['id'], this.tag);
            this.editTagMutation(data);
            this.$store.commit(SET_SNACKBAR_STATUS, { message: 'Tag updated successfully', color: 'success' });
            this.hideModal();
        },
        hideModal() {
            this.$emit('hide');
        },
    },
};
</script>
